<!--  -->
<template>
  <div class="lungcancer">
    <HomeNav></HomeNav>
    <PhoneNav></PhoneNav>
    <CrumbsNav :crumbsnav="crumbsnav"></CrumbsNav>
    <div class="change-cancer">
      <ul>
        <li
          v-for="(item, index) in changeCancer"
          :class="{ active: index === cancerShow }"
          :key="index"
          @click="onCancer(index)"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>
    <LungCancer v-show="onChangecancer"></LungCancer>
    <Manzu v-show="!onChangecancer"></Manzu>
    <BottomNav></BottomNav>
  </div>
</template>

<script>
import HomeNav from "../../components/HomeNav.vue";
import PhoneNav from "../../components/PhoneNav.vue";
import CrumbsNav from "../../components/CrumbsNav.vue";
import LungCancer from "../../components/product/LungCancer.vue";
import Manzu from "../../components/product/ManZu.vue";
import BottomNav from "../../components/BottomNav.vue";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    HomeNav,
    PhoneNav,
    CrumbsNav,
    LungCancer,
    Manzu,
    BottomNav,
  },
  data() {
    //这里存放数据
    return {
      crumbsnav: [
        /* 
        {
          title: "首页",
          url: "/index",
        },
        {
          title: "关于堃博",
          url: "/aboutUs*",
        },
       */
      ],
      changeCancer: [
        {
          title: "", //肺癌
        },
        {
          title: "", //慢阻肺
        },
      ],
      cancerShow: 0,
      onChangecancer: true,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onCancer(val) {
      this.cancerShow = val;
      if (val == 1) {
        this.onChangecancer = false;
      } else {
        this.onChangecancer = true;
      }
    },
    //面包屑(患者关爱)
    get_mianbao() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        async: false,
        data: {
          act: "get_all_nav_parent",
          nid: 34,
          showlast: 1,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.crumbsnav = [];
            $.each(obj.data, function (i, k) {
              that.crumbsnav.push({
                title: k.title,
                url: k.url,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.changeCancer[0].title = obj.data["fa"];
            that.changeCancer[1].title = obj.data["mzf"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_mianbao();
    this.get_fanyi();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.lungcancer {
  .change-cancer {
    width: $main-width;
    margin: 0 auto 40px;
    ul {
      display: flex;
      justify-content: flex-end;
      li {
        padding: 10px 20px;
        color: #666;
        transition: 0.3s;
        cursor: pointer;
      }
      li:hover {
        background: #9649be;
        color: #fff;
      }
      .active {
        background: #9649be;
        color: #fff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/product/lungcancer.vue